export const BLOG_NAVBAR_CONTAINER_ID = 'mercury-blog-navbar-container'
